import { MDText } from 'i18n-react';

import { KYC_BASE_PATH } from 'Components/pages/AccountSettings/AccountSettingsCompanyInformation/AccountSettingsCompanyInformation.helpers';
import { useIsKycFrozen } from 'Utilities/hooks/useIsKycFrozen/useIsKycFrozen';

import LocalTexts from '../SitewideBanner.texts';
import type { BannerConfig } from '../SitewideBanner.types';

const localT = new MDText(LocalTexts.kycFrozenCTA);

const id = 'kycFrozenCTA';

const texts = {
	linkLabel: localT.translate('linkLabel'),
	text: localT.translate('text'),
	title: localT.translate('title'),
} as Record<keyof typeof LocalTexts.kycFrozenCTA, string>;

export const useKycFrozenBannerConfig = (): BannerConfig => {
	const { isKycFrozen } = useIsKycFrozen();

	return {
		id,
		isDismissible: false,
		isEnabled: isKycFrozen,
		linkProps: { href: KYC_BASE_PATH },
		priorityIndex: 100000,
		shouldExpire: false,
		texts,
	};
};
